import React from 'react';
import styled, { css } from 'styled-components';
import TextButton from '../common/TextButton';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';

type Props = {
  type: { eng: string; kor: string; isFillColor?: boolean }[];
  location: { eng: string; kor: string };
  time: string;
  tel?: string;
  imgSrc?: string;
  mapSrc?: string;
  viewMap?: string;
};

const SectionCard = ({
  type,
  location,
  time,
  tel,
  imgSrc,
  mapSrc,
  viewMap,
}: Props) => {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;
  const dispatch = useAppDispatch();

  const onClickLocation = () => {
    if (viewMap) {
      return window.open(viewMap, '_blank');
    }
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: {
        type: 'LOCATION_PRINT',
        isActive: true,
        data: {
          title: location[nationality === 'KOR' ? 'kor' : 'eng'],
          imgSrc: mapSrc,
        },
      },
    });
  };

  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    openTime: ['Open Time', '운영시간'],
    tel: ['Tel', '전화번호'],
    viewMap: ['View Map', '약도 보기'],
  };

  return (
    <SectionWrapper>
      <TextWrapper>
        <BadgeList>
          {type.map(({ eng, kor, isFillColor = false }, index) => (
            <SectionBadge key={index} isFillColor={isFillColor}>
              {nationality === 'KOR' ? kor : eng}
            </SectionBadge>
          ))}
        </BadgeList>
        <SectionTitle>
          {nationality === 'KOR' ? location.kor : location.eng}
        </SectionTitle>
        {time && (
          <SectionInfo>
            {text.openTime[nationIndex]} : {time}
          </SectionInfo>
        )}
        {tel && (
          <SectionInfo>
            {text.tel[nationIndex]} : {tel}
          </SectionInfo>
        )}
      </TextWrapper>
      <SectionImg src={imgSrc} alt='' />
      {mapSrc && (
        <TextButton
          title={text.viewMap[nationIndex]}
          onClick={onClickLocation}
          color='#246CF6'
          bgColor='#E9F0FE'
          margin='0'
          width='100%'
        />
      )}
    </SectionWrapper>
  );
};

export default SectionCard;

const SectionWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid #e5e6e8;
  width: 100%;
  padding: 24px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;

const BadgeList = styled.ul`
  display: flex;
  gap: 6px;
`;

const SectionBadge = styled.li<{ isFillColor?: boolean }>`
  display: inline-block;
  border-radius: 6px;
  padding: 2px 8px;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.24px;
  ${({ isFillColor }) =>
    isFillColor
      ? css`
          background: #111111;
          color: #ffffff;
        `
      : css`
          background: #e5e6e8;
          color: #3a3b3e;
        `}
`;

const SectionTitle = styled.strong`
  display: block;
  color: #3a3b3e;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
`;

const SectionInfo = styled.p`
  color: #80848a;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const SectionImg = styled.img`
  width: 100%;
  margin: 16px 0;
`;
